import { render } from "./SalOn.vue?vue&type=template&id=587ebb29&scoped=true"
import script from "./SalOn.vue?vue&type=script&lang=js"
export * from "./SalOn.vue?vue&type=script&lang=js"

import "./SalOn.vue?vue&type=style&index=0&id=587ebb29&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587ebb29"]])

export default __exports__